import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStudentMe } from '@/hooks/useStudentMe';
import { LoadingState } from '@/components/LoadingState';

interface RequireStudentProps {
  children: ReactNode;
}

/**
 * Blocking route guard for `/student/*` (except `/student/login`). Mirrors
 * `RequireAuth` but runs the `/student/me` check and redirects unauthenticated
 * users to `/student/login`, preserving the deep link in `next`. Strictly
 * separate from the teacher guard.
 */
export function RequireStudent({ children }: RequireStudentProps): JSX.Element {
  const location = useLocation();
  const me = useStudentMe();

  if (me.isPending) {
    return <LoadingState variant="spinner" label="Anmeldestatus wird geprüft …" />;
  }

  if (me.isError || !me.data) {
    const nextParam = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/student/login?next=${nextParam}`} replace />;
  }

  return <>{children}</>;
}
